import styled from "styled-components";

export const ReviewQuestionsModalWrapper = styled.div`
.buttons{
    display: flex;
    justify-content: center;
    gap: 15px;
}
p{
    font-size: 14px;
    font-family: math;
}
`;